import tippy from 'tippy.js'

export default function Tooltip () {
  tippy('[data-tippy-content]', {
    theme: 'mtt',
    placement: 'top'
  })
}
